// React
import React, { useState, useCallback } from 'react';
import { CardHeader, Row } from 'reactstrap';

// DataTable
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';

// Scss
// import 'react-data-table-component-extensions/dist/index.css'; => default style of search by dist.
import '../../../../../../../../assets/scss/pages/_datatable-search.scss';

// Components
import { ModalDelete } from '../../../../../../containers/componentsInjection';

export const DatatableSchedule = ({
  data,
  title,
  isCard,
  columns,
  children,
  handleEdit,
  titleButton,
  handleButton,
  handleDelete,
  actions = [],
  keySearch = 'name',
  toggleModalRealized,
  toggleModalHistoric,
  ...rest
}) => {
  const [isHover, setIsHover] = useState(0);
  const [registerId, setRegisterId] = useState(null);
  const [modal_delete, setModal_delete] = useState(false);

  const toggleModal = useCallback(
    (id) => {
      setRegisterId(id);
      setModal_delete(!modal_delete);
    },
    [modal_delete]
  );

  return (
    <div>
      <>
        <CardHeader className="border-bottom-dashed">
          <Row className="g-4 align-items-center">
            <div className="col-sm">
              <div>
                <h5 className="card-title mb-0">{title}</h5>
              </div>
            </div>
            <div className="col-sm-auto">
              <div>
                <button
                  type="button"
                  className="btn btn-success add-btn"
                  id="create-btn"
                  onClick={() => {
                    handleButton();
                  }}
                >
                  <i className="ri-add-line align-bottom me-1"></i>
                  {titleButton}
                </button>{' '}
              </div>
            </div>
          </Row>
        </CardHeader>

        {children}

        <div className="card-body">
          <div className="table-responsive table-card mb-1">
            <DataTableExtensions
              {...rest}
              columns={[
                ...columns,
                {
                  name: <span className="font-weight-bold fs-13"> </span>,
                  sortable: false,
                  style: {
                    justifyContent: 'end',
                  },
                  cell: (cellProps) => {
                    return (
                      <ul
                        className="list-inline hstack gap-2 mb-0 "
                        style={{
                          display: isHover === cellProps.id ? 'flex' : 'none',
                          cursor: 'pointer',
                        }}
                      >
                        {cellProps.status.title === 'Realizada' ? (
                          <li
                            title="Ver Histórico"
                            onClick={() => toggleModalHistoric(cellProps)}
                          >
                            <i className="las la-file-invoice fs-20 text-primary"></i>
                          </li>
                        ) : (
                          <>
                            <li
                              title="Marcar como Realizado"
                              onClick={() => toggleModalRealized(cellProps)}
                            >
                              <i className="las la-check-circle fs-20 text-success"></i>
                            </li>
                            <li
                              title="Editar"
                              onClick={() => handleEdit(cellProps)}
                            >
                              <i className="las la-pen fs-20 text-primary"></i>
                            </li>
                            <li
                              title="Remover"
                              onClick={() => toggleModal(cellProps)}
                            >
                              <i className="las la-trash-alt fs-20 text-danger"></i>
                            </li>
                          </>
                        )}
                      </ul>
                    );
                  },
                },
              ]}
              data={data}
              print={false}
              export={false}
              filterPlaceholder="Pesquisar..."
            >
              <DataTable
                {...rest}
                onRowMouseEnter={(row) => {
                  setIsHover(row.id);
                }}
                onRowMouseLeave={() => {
                  setIsHover(0);
                }}
                paginationComponentOptions={{
                  rowsPerPageText: 'Linhas por página:',
                  rangeSeparatorText: 'de',
                  selectAllRowsItem: true,
                  selectAllRowsItemText: 'Todos',
                }}
              />
            </DataTableExtensions>

            <ModalDelete
              isOpen={modal_delete}
              handleDelete={() => {
                handleDelete(registerId);
                setModal_delete(!modal_delete);
              }}
              goBack={() => setModal_delete(!modal_delete)}
            />
          </div>
        </div>
      </>
    </div>
  );
};
